(() => {
  const motion = matchMedia('(prefers-reduced-motion: no-preference) and (hover: hover)');
  document.querySelectorAll('.dryzane-private__spread figure, .dz-editorial__media').forEach(surface => {
    surface.addEventListener('pointermove', event => {
      if (!motion.matches) return;
      const box = surface.getBoundingClientRect();
      const x = (event.clientX - box.left) / box.width - 0.5;
      const y = (event.clientY - box.top) / box.height - 0.5;
      surface.style.setProperty('--depth-x', `${-y * 2}deg`);
      surface.style.setProperty('--depth-y', `${x * 2}deg`);
    });
    surface.addEventListener('pointerleave', () => {
      surface.style.setProperty('--depth-x', '0deg');
      surface.style.setProperty('--depth-y', '0deg');
    });
  });
  const dialog = document.querySelector('[data-wheel-dialog]');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  let trigger;
  let previousOverflow;
  const open = () => {
    previousOverflow = document.documentElement.style.overflow;
    dialog.showModal();
    document.documentElement.style.overflow = 'hidden';
  };
  document.querySelectorAll('[data-wheel-enquiry]').forEach(link => {
    link.addEventListener('click', event => {
      if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      const interest = dialog.querySelector('#WheelInterest');
      if (!interest) return;
      event.preventDefault();
      trigger = link;
      interest.value = link.dataset.productTitle;
      dialog.querySelector('[data-wheel-handle]').value = link.dataset.productHandle;
      dialog.querySelector('[data-wheel-handle]').setAttribute('value', link.dataset.productHandle);
      const details = dialog.querySelector('[data-wheel-product-link]');
      details.href = link.dataset.productUrl;
      details.hidden = false;
      open();
    });
  });
  dialog.querySelector('[data-close-quote]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => {
    document.documentElement.style.overflow = previousOverflow || '';
    trigger?.focus();
  });
  if (dialog.querySelector('[data-wheel-result]')) open();
})();
